<mat-card
  *ngIf="(profileCompleted$ | async) === false && !loading"
  class="incomplete-profile-warning top-gap"
>
  <mat-card-content>
    Your profile is still incomplete, you won't be able to post your services or
    contact service providers until it's completed. Click
    <a routerLink="/my-profile">here</a> to go to the
    <strong>My Profile</strong> page.
  </mat-card-content>
</mat-card>
